import { render, staticRenderFns } from "./dialogComponent.vue?vue&type=template&id=776847c8&scoped=true&"
import script from "./dialogComponent.vue?vue&type=script&lang=js&"
export * from "./dialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./dialogComponent.vue?vue&type=style&index=0&id=776847c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776847c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('776847c8')) {
      api.createRecord('776847c8', component.options)
    } else {
      api.reload('776847c8', component.options)
    }
    module.hot.accept("./dialogComponent.vue?vue&type=template&id=776847c8&scoped=true&", function () {
      api.rerender('776847c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/dialogComponent.vue"
export default component.exports